<template>
  <div>
    <div class="table-wrapper" id="table-wrapper">
      <table class="custom-table responsive-table border-collapse">
        <thead class="font-normal">
          <tr class="shadow-table rounded-lg">
            <th class="checkbox">
              <base-checkbox />
            </th>
            <th>Shipping ID #</th>
            <th>Customer</th>
            <th>Total Cost</th>
            <th>Partner Earning (NGN)</th>
            <th>Payment Mode </th>
            <!-- <th>Payment Mode + Date</th> -->
            <th>Customer Profile</th>
            <th>Status</th>
            <th tabindex="-1">
              <span @click="showFilterModal = true" class="cursor-pointer">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g opacity="0.7">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M4 0.130371C5.86384 0.130371 7.42994 1.46057 7.87398 3.26081H16V5.34776H7.87398C7.42994 7.148 5.86384 8.4782 4 8.4782C1.79086 8.4782 0 6.60947 0 4.30428C0 1.9991 1.79086 0.130371 4 0.130371ZM4 6.39124C5.10457 6.39124 6 5.45688 6 4.30428C6 3.15169 5.10457 2.21733 4 2.21733C2.89543 2.21733 2 3.15169 2 4.30428C2 5.45688 2.89543 6.39124 4 6.39124Z"
                      fill="#383F51"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M14 17.8695C12.1362 17.8695 10.5701 16.5393 10.126 14.7391H2V12.6521H10.126C10.5701 10.8519 12.1362 9.52168 14 9.52168C16.2091 9.52168 18 11.3904 18 13.6956C18 16.0008 16.2091 17.8695 14 17.8695ZM14 15.7825C15.1046 15.7825 16 14.8482 16 13.6956C16 12.543 15.1046 11.6086 14 11.6086C12.8954 11.6086 12 12.543 12 13.6956C12 14.8482 12.8954 15.7825 14 15.7825Z"
                      fill="#383F51"
                    />
                  </g></svg
              ></span>
            </th>
          </tr>
        </thead>
        <tbody v-if="!loading">
          <tr
            v-for="(settlement, index) in tableContent"
            :key="settlement.id"
            class="shadow-table rounded-lg"
          >
            <td>
              <base-checkbox />
            </td>
            <td>
              {{ settlement.shippingReference }}

              <span class="block w-max opacity-50">
                {{
                  settlement.createdAt
                    ? settlement.createdAt.split("T")[0]
                    : "N/A"
                }}
              </span>
            </td>

            <td class="d-flex flex-row">
              <span class="w-max mt-2 mr-2">
                {{ settlement.user ? settlement.user.firstname : "N/A" }}
              </span>
              <span class="w-max mt-2">
                {{ settlement.user ? settlement.user.lastname : "" }}
              </span>
            </td>
            <td>₦{{ settlement.totalCost }}</td>

            <td>
              {{ settlement.partnerEarning.toFixed(2) || "N/A" }}
            </td>

            <td>{{ settlement.transaction.payment_type }}</td>
            <td>
              {{ settlement.user ? settlement.user.accounttype : "N/A" }}
            </td>
            <td>
              <span
                :class="[true ? statusBg(settlement.transaction.status) : null]"
                >{{ settlement.transaction.status }}</span
              >
            </td>
            <td
              tabindex="-1"
              @blur="selectedRowId = null"
              class="table__action-btn cursor-pointer relative"
            >
              <span
                class="-full flex justify-center"
                @click="selectedRowId = index"
              >
                <span
                  class="icon"
                  @click="transactionRoute(settlement.transaction.id)"
                >
                  <img
                    alt=""
                    class="mr-1"
                    src="@/assets/images/billing/icon-eye-alt.svg"
                /></span>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <EmptyContent v-if="!tableContent.length" />

    <TableHeaderSettlementFilter
      :show-modal="showFilterModal"
      @close-modal="showFilterModal = false"
    />
    <CollectPayment
      :show-modal="collectPaymentModal"
      @close-modal="collectPaymentModal = false"
    />
  </div>
</template>

<script>
import TableHeaderSettlementFilter from "../modals/TableHeaderSettlementFilter.vue";
import CollectPayment from "../modals/CollectPayment.vue";

import EmptyContent from "../svg/EmptyContent.vue";

export default {
  components: {
    TableHeaderSettlementFilter,
    CollectPayment,

    EmptyContent,
  },
  props: ["tableContent"],
  data() {
    return {
      loading: false,

      showFilterModal: false,
      collectPaymentModal: false,
      selectedRowId: -1,
    };
  },
  methods: {
    statusBg(val) {
      let bg = "";
      switch (val) {
        case "pending":
          bg = "text-red-500";
          break;

        case "estimate":
          bg = "text-primary-yellow";
          break;

        default:
          bg = "text-teal-500";
          break;
      }
      return bg;
    },

    transactionRoute(val) {
      if (!val) return;
      localStorage.setItem("billing_reciept", "quote");
      this.$router.push({ name: "BCM_reciept", params: { id: val } });
    },
  },
};
</script>

<style lang="scss" scoped>
.actions {
  @apply w-auto absolute right-0 bg-white shadow-md z-10 py-3 px-2;

  min-width: 184px;
}
.actions div {
  @apply flex w-full py-2 px-2 items-center;
}
.icon {
  width: auto;
  padding-right: 5px;
}
tbody tr td {
  // word-break: break-all;

  font-size: 13px;
}
tbody tr td:nth-last-child(2) {
  width: calc(100% / 9);
}

#table-wrapper {
  margin: 2rem 0 0;
  overflow-x: auto;
}
.table-wrapper,
.table-wrapper .custom-table {
  transform: rotateX(180deg);
  -ms-transform: rotateX(180deg);
  -webkit-transform: rotateX(180deg);
}
/* width */
.table-wrapper::-webkit-scrollbar {
  cursor: pointer;
  width: 5px;
  height: 8px;
}
/* Track */
.table-wrapper::-webkit-scrollbar-track {
  background: #c4c4c4;
}
/* Handle */
.table-wrapper::-webkit-scrollbar-thumb {
  background: #fab427;
  width: 5px;
  border-radius: 20px;
}
</style>
